var map = {
	"./IMG_2836@2x.png": 1021,
	"./add_image@2x.png": 1022,
	"./button_arrowdown@2x.png": 1023,
	"./clearbutton@2x.png": 1024,
	"./dl_andriod_blue@2x.png": 1025,
	"./dl_android_outline@2x.png": 1026,
	"./dl_apple_blue@2x.png": 1027,
	"./dl_appstore@2x.png": 1028,
	"./dl_appstore_hover_yl@2x.png": 1029,
	"./dl_appstore_outline@2x.png": 1030,
	"./dl_appstore_white@2x.png": 1031,
	"./dl_playstore@2x.png": 1032,
	"./dl_playstore_hover_yl@2x.png": 1033,
	"./dl_playstore_white@2x.png": 1034,
	"./feature_lightbox1_en@2x.png": 1035,
	"./feature_lightbox2@2x.png": 1036,
	"./feature_lightbox3@2x.png": 1037,
	"./feature_lightbox4_en@2x.png": 1038,
	"./feature_lightbox5_en@2x.png": 1039,
	"./feature_lightbox6_en@2x.png": 1040,
	"./hero_iphone_en@2x.png": 1041,
	"./hero_nexus_en@2x.png": 1042,
	"./hero_video@2x.png": 1043,
	"./hero_video_hover@2x.png": 1044,
	"./icon-building-materials-transport@2x.png": 1045,
	"./icon-courier@2x.png": 1046,
	"./icon-delivery@2x.png": 1047,
	"./icon-how-it-work-step1_en@2x.png": 1048,
	"./icon-how-it-work-step2@2x.png": 1049,
	"./icon-how-it-work-step3@2x.png": 1050,
	"./icon-pet-shuttle-service@2x.png": 1051,
	"./icon-right@2x.png": 1052,
	"./icon-send-document@2x.png": 1053,
	"./icon-supplies-moving@2x.png": 1054,
	"./icon-warehouse-transport@2x.png": 1055,
	"./icon_5ton_blue@2x.png": 1056,
	"./icon_5ton_white@2x.png": 1057,
	"./icon_9ton_blue@2x.png": 1058,
	"./icon_9ton_white@2x.png": 1059,
	"./icon_add@2x.png": 1060,
	"./icon_add_disabled@2x.png": 1061,
	"./icon_add_hover@2x.png": 1062,
	"./icon_avatar@2x.png": 1063,
	"./icon_avator40x40@2x.png": 1064,
	"./icon_avator70x70@2x.png": 1065,
	"./icon_birthday@2x.png": 1066,
	"./icon_borrowcart_inactive@2x.png": 1067,
	"./icon_calendar@2x.png": 1068,
	"./icon_calendar_solidblue@2x.png": 1069,
	"./icon_camera@2x.png": 1070,
	"./icon_camera_disabled@2x.png": 1071,
	"./icon_camera_hover@2x.png": 1072,
	"./icon_clear_2@2x.png": 1073,
	"./icon_clear_b@2x.png": 1074,
	"./icon_clock@2x.png": 1075,
	"./icon_clock_small@2x.png": 1076,
	"./icon_constructionwaste_inactive@2x.png": 1077,
	"./icon_courier@2x.png": 1078,
	"./icon_courier_blue@2x.png": 1079,
	"./icon_courier_white@2x.png": 1080,
	"./icon_cross_r@2x.png": 1081,
	"./icon_deliveryservice@2x.png": 1082,
	"./icon_deliveryservice_blue@2x.png": 1083,
	"./icon_deliveryservice_white@2x.png": 1084,
	"./icon_done@2x.png": 1085,
	"./icon_email@2x.png": 1086,
	"./icon_english_inactive@2x.png": 1087,
	"./icon_facebook@2x.png": 1088,
	"./icon_feature1@2x.png": 1089,
	"./icon_feature2@2x.png": 1090,
	"./icon_feature3@2x.png": 1091,
	"./icon_feature4@2x.png": 1092,
	"./icon_feature5@2x.png": 1093,
	"./icon_feature6@2x.png": 1094,
	"./icon_from@2x.png": 1095,
	"./icon_gender@2x.png": 1096,
	"./icon_googleplus@2x.png": 1097,
	"./icon_home_address@2x.png": 1098,
	"./icon_hourlyrental_inactive@2x.png": 1099,
	"./icon_industry@2x.png": 1100,
	"./icon_instagram@2x.png": 1101,
	"./icon_linkedin@2x.png": 1102,
	"./icon_loading_complete@2x.png": 1103,
	"./icon_loading_small@2x.png": 1104,
	"./icon_location_1@2x.png": 1105,
	"./icon_location_2@2x.png": 1106,
	"./icon_locations_full@2x.png": 1107,
	"./icon_longergood_inactive@2x.png": 1108,
	"./icon_mail@2x.png": 1109,
	"./icon_mid@2x.png": 1110,
	"./icon_motorcycle_blue@2x.png": 1111,
	"./icon_motorcycle_white@2x.png": 1112,
	"./icon_moving@2x.png": 1113,
	"./icon_moving_w@2x.png": 1114,
	"./icon_movingservice@2x.png": 1115,
	"./icon_movingservice_blue@2x.png": 1116,
	"./icon_movingservice_white@2x.png": 1117,
	"./icon_naver@2x.png": 1118,
	"./icon_newcar_inactive@2x.png": 1119,
	"./icon_notification@2x.png": 1120,
	"./icon_ordering_hourly_clock@2x.png": 1121,
	"./icon_passengerservice@2x.png": 1122,
	"./icon_passengervan@2x.png": 1123,
	"./icon_passengervan_w@2x.png": 1124,
	"./icon_password@2x.png": 1125,
	"./icon_pets_inactive@2x.png": 1126,
	"./icon_phone@2x.png": 1127,
	"./icon_phone_white@2x.png": 1128,
	"./icon_phone_white_big@2x.png": 1129,
	"./icon_porterage_inactive@2x.png": 1130,
	"./icon_question@2x.png": 1131,
	"./icon_question_hover@2x.png": 1132,
	"./icon_rate@2x.png": 1133,
	"./icon_rate_y@2x.png": 1134,
	"./icon_ridewithgood_blue@2x.png": 1135,
	"./icon_ridewithgood_white@2x.png": 1136,
	"./icon_ridewithgoodsicon@2x.png": 1137,
	"./icon_ridewithgoodsicon_blue@2x.png": 1138,
	"./icon_ridewithgoodsicon_white@2x.png": 1139,
	"./icon_selected@2x.png": 1140,
	"./icon_send_to@2x.png": 1141,
	"./icon_ser_10ftlorry@2x.png": 1142,
	"./icon_ser_14ftlorry@2x.png": 1143,
	"./icon_ser_24ftlorry@2x.png": 1144,
	"./icon_ser_bike@2x.png": 1145,
	"./icon_ser_courier@2x.png": 1146,
	"./icon_ser_delivery@2x.png": 1147,
	"./icon_ser_everythingelse@2x.png": 1148,
	"./icon_ser_moving@2x.png": 1149,
	"./icon_ser_passenger@2x.png": 1150,
	"./icon_ser_smallfreight@2x.png": 1151,
	"./icon_ser_van@2x.png": 1152,
	"./icon_smallfreight@2x.png": 1153,
	"./icon_smallfreight_blue@2x.png": 1154,
	"./icon_smallfreight_white@2x.png": 1155,
	"./icon_steps1@2x.png": 1156,
	"./icon_steps1_activated@2x.png": 1157,
	"./icon_steps2@2x.png": 1158,
	"./icon_steps2_activated@2x.png": 1159,
	"./icon_steps3@2x.png": 1160,
	"./icon_steps3_activated@2x.png": 1161,
	"./icon_to@2x.png": 1162,
	"./icon_twitter@2x.png": 1163,
	"./icon_van@2x.png": 1164,
	"./icon_van_blue@2x.png": 1165,
	"./icon_van_white@2x.png": 1166,
	"./icon_work_address@2x.png": 1167,
	"./icon_youtube@2x.png": 1168,
	"./img_404@2x.png": 1169,
	"./img_driverprofile_fallback@2x.png": 1170,
	"./img_step1@2x.png": 1171,
	"./index_hero/gogobusiness/gogovan_logo@2x.png": 1172,
	"./index_hero/gogobusiness/imac@2x.png": 1173,
	"./india@2x.png": 1174,
	"./map_marker_1@2x.png": 1175,
	"./map_marker_2@2x.png": 1176,
	"./map_marker_3@2x.png": 1177,
	"./map_marker_4@2x.png": 1178,
	"./map_marker_5@2x.png": 1179,
	"./map_marker_6@2x.png": 1180,
	"./map_marker_7@2x.png": 1181,
	"./map_marker_8@2x.png": 1182,
	"./map_marker_9@2x.png": 1183,
	"./media_36kr@2x.png": 1184,
	"./media_appledaily@2x.png": 1185,
	"./media_channelnewsasia@2x.png": 1186,
	"./media_d100@2x.png": 1187,
	"./media_e27@2x.png": 1188,
	"./media_econtimes@2x.png": 1189,
	"./media_ezone@2x.png": 1190,
	"./media_ibt@2x.png": 1191,
	"./media_metro_broadcast@2x.png": 1192,
	"./media_pcm@2x.png": 1193,
	"./media_rthk@2x.png": 1194,
	"./media_singtao@2x.png": 1195,
	"./media_techcrunch@2x.png": 1196,
	"./media_techinasia@2x.png": 1197,
	"./media_thestraitstimes@2x.png": 1198,
	"./media_unwire@2x.png": 1199,
	"./media_weekender@2x.png": 1200,
	"./media_wsj@2x.png": 1201,
	"./nav_logo@2x.png": 1202,
	"./partnerships_ikea@2x.png": 1203,
	"./partnerships_kfc@2x.png": 1204,
	"./partnerships_logos_eprint@2x.png": 1205,
	"./partnerships_logos_spacious@2x.png": 1206,
	"./partnerships_nike@2x.png": 1207,
	"./partnerships_pizzahut@2x.png": 1208,
	"./partnerships_pricerite@2x.png": 1209,
	"./pricing_icon@2x.png": 1210,
	"./steps_video@2x.png": 1211,
	"./steps_video_hover@2x.png": 1212,
	"./swire@2x.png": 1213,
	"./verify_sender_phone@2x.png": 1214,
	"./world_map_dots@2x.png": 1215,
	"./yellowtip@2x.png": 1216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img ^\.\/.*@2x\.png$
// module id = 971
// module chunks = 0